import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e557500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-5 text-sm" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "info-grid" }
const _hoisted_4 = { class: "input-form-label text-gray-500" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "card"
}
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "w-full text-left text-sm" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-gray-200 text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-4 font-medium" }, "Поле"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 pr-4 font-medium" }, "Было"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2 font-medium" }, "Стало")
  ])
], -1))
const _hoisted_11 = { class: "py-2 pr-4 font-medium text-gray-700" }
const _hoisted_12 = { class: "py-2 pr-4 text-gray-500" }
const _hoisted_13 = { class: "py-2 text-gray-900" }
const _hoisted_14 = {
  key: 2,
  class: "card"
}
const _hoisted_15 = { class: "info-grid" }
const _hoisted_16 = { class: "md:col-span-2" }
const _hoisted_17 = { class: "input-form-label" }
const _hoisted_18 = { class: "mt-1 text-gray-800" }
const _hoisted_19 = { class: "mt-1 text-xs text-gray-500" }

import {
  computed,
  defineComponent,
  h,
  PropType,
  withDefaults,
} from "vue";

import StatusLabel from "@/components/common/StatusLabel.vue";
import { t } from "@/i18n";
import { EEntityScope } from "@/types/common/entityApproval/EntityApproval";

interface UserPayload {
  id?: string | null;
  login?: string | null;
  email?: string | null;
  password?: string | null;
  iin?: string | null;
  status?: string | null;
  name?: string | null;
  surname?: string | null;
  middleName?: string | null;
  company?: string | null;
  companyName?: string | null;
  job?: string | null;
  jobName?: string | null;
  roleIds?: string[];
  roleNames?: string[];
  userType?: string | null;
  viewScope?: string | null;
  editScope?: string | null;
  viewDirectorateIds?: string[] | null;
  editDirectorateIds?: string[] | null;
  coordinatorId?: string | null;
  coordinatorName?: string | null;
}

type UserPayloadSection = "all" | "overview" | "access";


export default /*#__PURE__*/_defineComponent({
  props: {
    payload: null,
    previousPayload: null,
    section: { default: "all" }
  },
  setup(__props: any) {

const props = __props as { payload: Record<string, unknown> | UserPayload, previousPayload?: Record<string, unknown> | UserPayload | null, section: UserPayloadSection }



const scopeEnum = EEntityScope;

const data = computed(() => props.payload as UserPayload);
const previousData = computed(() => (props.previousPayload || null) as UserPayload | null);

const showSection = (section: Exclude<UserPayloadSection, "all">) => {
  return props.section === "all" || props.section === section;
};

const hasScope = computed(() => {
  return data.value.viewScope != null || data.value.editScope != null;
});

const fullName = computed(() => {
  const nameParts = [
    data.value.surname,
    data.value.name,
    data.value.middleName,
  ].filter(Boolean);

  return nameParts.length ? nameParts.join(" ") : "—";
});

const userTypeLabel = computed(() => {
  const labels: Record<string, string> = {
    INTERNAL: t("userForm.userTypeInternal"),
    EXTERNAL: t("userForm.userTypeExternal"),
  };
  return data.value.userType ? labels[data.value.userType] ?? "—" : "—";
});

const coordinatorLabel = computed(() => {
  return data.value.coordinatorId == null
    ? t("entityScope.coordinatorAny")
    : resolvedName(data.value.coordinatorName, data.value.coordinatorId);
});

const scopeLabel = (scope?: string | null) => {
  const labels: Record<string, string> = {
    [EEntityScope.PRIVATE]: t("entityScope.private"),
    [EEntityScope.UNIT]: t("entityScope.unit"),
    [EEntityScope.MULTI_UNIT]: t("entityScope.multiUnit"),
    [EEntityScope.ALL]: t("entityScope.all"),
  };

  return scope ? labels[scope] ?? scope : "—";
};

const formatIds = (ids?: string[] | null) => {
  return ids && ids.length ? ids.join(", ") : "—";
};

const formatNames = (names?: string[] | null) => {
  return names && names.length ? names.join(", ") : "—";
};

const resolvedName = (name?: string | null, id?: string | null) => {
  return name && name !== String(id) ? name : "—";
};

const formatList = (value?: Array<string | number> | null) => {
  return value && value.length ? value.join(", ") : "—";
};

const valueByKey = (payload: UserPayload | null, key: string) => {
  if (!payload) {
    return "—";
  }

  const values: Record<string, string> = {
    fullName: [payload.surname, payload.name, payload.middleName]
      .filter(Boolean)
      .join(" "),
    company: resolvedName(payload.companyName, payload.company),
    job: resolvedName(payload.jobName, payload.job),
    roleIds: formatList(payload.roleNames || payload.roleIds),
    userType: payload.userType ? userTypeLabelByValue(payload.userType) : "—",
    viewScope: scopeLabel(payload.viewScope),
    editScope: scopeLabel(payload.editScope),
    coordinatorId:
      payload.coordinatorId == null
        ? t("entityScope.coordinatorAny")
        : resolvedName(payload.coordinatorName, payload.coordinatorId),
  };

  const value = values[key] ?? (payload as Record<string, unknown>)[key];
  if (Array.isArray(value)) {
    return formatList(value as Array<string | number>);
  }
  return value == null || value === "" ? "—" : String(value);
};

const normalizeValue = (value: string) => value.trim();

const userTypeLabelByValue = (value?: string | null) => {
  const labels: Record<string, string> = {
    INTERNAL: t("userForm.userTypeInternal"),
    EXTERNAL: t("userForm.userTypeExternal"),
  };
  return value ? labels[value] ?? value : "—";
};

const comparableFields = computed(() => [
  { key: "fullName", label: t("common.name") },
  { key: "login", label: t("profile.login") },
  { key: "iin", label: t("common.iin") },
  { key: "email", label: "Email" },
  { key: "status", label: t("common.status") },
  { key: "userType", label: t("userForm.userType") },
  { key: "company", label: t("common.company") },
  { key: "job", label: t("common.job") },
  { key: "roleIds", label: t("common.role") },
  { key: "viewScope", label: t("entityScope.viewScope") },
  { key: "editScope", label: t("entityScope.editScope") },
  { key: "coordinatorId", label: t("entityScope.coordinator") },
]);

const changedFields = computed(() => {
  if (!previousData.value) {
    return [];
  }

  return comparableFields.value
    .map((field) => {
      const before = valueByKey(previousData.value, field.key);
      const after = valueByKey(data.value, field.key);
      return { ...field, before, after };
    })
    .filter(
      (field) => normalizeValue(field.before) !== normalizeValue(field.after)
    );
});

const SectionTitle = defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    return () =>
      h(
        "h2",
        {
          class: "mb-5 text-lg font-semibold text-gray-800",
        },
        props.title
      );
  },
});

const InfoItem = defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },

    value: {
      type: [String, Number] as PropType<string | number>,
      default: "—",
    },
  },

  setup(props, { slots, attrs }) {
    return () =>
      h("div", attrs, [
        h(
          "span",
          {
            class: "input-form-label text-gray-500",
          },
          props.label
        ),

        h(
          "p",
          {
            class: "mt-1 break-words text-gray-800",
          },
          slots.default ? slots.default() : String(props.value || "—")
        ),
      ]);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSection('overview'))
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('entityApproval.user.mainInfo')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('common.name'),
              value: _unref(fullName)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('profile.login'),
              value: _unref(data).login || '—'
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('common.iin'),
              value: _unref(data).iin ? String(_unref(data).iin) : '—'
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: "Email",
              value: _unref(data).email || '—'
            }, null, 8, ["value"]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("common.status")), 1),
              _createElementVNode("div", _hoisted_5, [
                (_unref(data).status)
                  ? (_openBlock(), _createBlock(StatusLabel, {
                      key: 0,
                      label: String(_unref(data).status)
                    }, null, 8, ["label"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
              ])
            ]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('userForm.userType'),
              value: _unref(userTypeLabel)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('common.company'),
              value: resolvedName(_unref(data).companyName, _unref(data).company)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('common.job'),
              value: resolvedName(_unref(data).jobName, _unref(data).job)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('common.role'),
              value: formatNames(_unref(data).roleNames)
            }, null, 8, ["label", "value"])
          ])
        ]))
      : _createCommentVNode("", true),
    (showSection('overview') && _unref(changedFields).length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createVNode(_unref(SectionTitle), { title: "Изменения" }),
          _createElementVNode("div", {
            class: "table-scroll",
            style: {"--table-min-width":"600px"},
            tabindex: "0",
            role: "region",
            "aria-label": _ctx.$t('common.scrollableTable')
          }, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(changedFields), (field) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: field.key,
                    class: "border-b border-gray-100 last:border-b-0"
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(field.label), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(field.before), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(field.after), 1)
                  ]))
                }), 128))
              ])
            ])
          ], 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    (showSection('access') && _unref(hasScope))
      ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
          _createVNode(_unref(SectionTitle), {
            title: _unref(t)('entityScope.title')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('entityScope.viewScope'),
              value: scopeLabel(_unref(data).viewScope)
            }, null, 8, ["label", "value"]),
            _createVNode(_unref(InfoItem), {
              label: _unref(t)('entityScope.editScope'),
              value: scopeLabel(_unref(data).editScope)
            }, null, 8, ["label", "value"]),
            (_unref(data).viewScope === _unref(scopeEnum).MULTI_UNIT)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 0,
                  label: _unref(t)('entityScope.viewDirectorates'),
                  value: formatIds(_unref(data).viewDirectorateIds)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (_unref(data).editScope === _unref(scopeEnum).MULTI_UNIT)
              ? (_openBlock(), _createBlock(_unref(InfoItem), {
                  key: 1,
                  label: _unref(t)('entityScope.editDirectorates'),
                  value: formatIds(_unref(data).editDirectorateIds)
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("entityScope.coordinator")), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(coordinatorLabel)), 1),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)("entityScope.coordinatorHint")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})